'use client';

import { SearchEngine, buildBreadcrumbManager } from '@coveo/atomic-react';
import { useEffect, useState } from 'react';

export const useBreadcrumbManager = (
  searchEngine: SearchEngine<{}> | undefined
) => {
  const [breadcrumbManagerController] = useState(
    searchEngine && buildBreadcrumbManager(searchEngine)
  );
  const [breadcrumbManagerState, setBreadcrumbManagerState] = useState(
    breadcrumbManagerController?.state
  );

  useEffect(() => {
    breadcrumbManagerController?.subscribe(() =>
      setBreadcrumbManagerState(breadcrumbManagerController.state)
    );
  }, [breadcrumbManagerController]);

  return { breadcrumbManagerState };
};
